module.exports = __webpack_public_path__ + "static/up4-7ae65e375d3b76652c0012982a005843.png";